import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../service/http.service';

@Injectable({
  providedIn: 'root'
})
export class AirportService {
  constructor(private httpService: HttpService) { }
  getAirport(params: any): Observable<any> {
    return this.httpService.get('airport', params);
  }
  getAirportforCreate(params: any): Observable<any> {
    return this.httpService.get('airport/create', params);
  }
  registerAirport(params: any): Observable<any> {
    return this.httpService.post('airport-register', params);
  }
}
